<template>
    <div>
        <v-card elevation="6" class="base-card-container pa-0 mt-4">
            <v-card-title class="pa-5 pb-3 primary">
                <v-icon class="pr-4" :color="'#FFFFFF'">mdi-cash</v-icon>
                <p style="color: white;">Conclusión Daños</p>

            </v-card-title>
            <v-form ref="form" v-model="validForm" lazy-validation>
                <v-card-text>
                    <v-row justify="center">
                        <v-col cols="12" md="6">
                            <div class="mt-2">
                                <span style="font-weight: bold;">Nombre del tercero:</span>
                                <p class="type-text-style">{{nombreTercero}}</p>
                            </div>
                            <v-divider class="mt-1"></v-divider>

                            <div class="mt-2">
                                <span style="font-weight: bold;">Término de daños:</span>
                                <v-radio-group :rules="rulesradios" v-model="datos.termino" style="margin: -1px; margin-left: 10px;">
                                    <v-radio label="Recuperamos del tercero" value="R"></v-radio>
                                    <v-radio label="Pagamos al tercero" value="P"></v-radio>
                                    <v-radio label="Irrecuperable" value="I"></v-radio>
                                    <v-radio label="Cada quién con sus daños" value="C"></v-radio>
                                    <v-radio label="Sin costo para la aseguradora" value="S"></v-radio>
                                    <v-radio label="Improcedente" value="M"></v-radio>
                                </v-radio-group>
                            </div>

                            

                            <div v-if="showRP">
                                <v-divider class="mt-1"></v-divider>
                                <div class="mt-2">
                                    <span style="font-weight: bold;">Pago en efectivo:</span>
                                    <v-text-field v-model="datos.pagoefectivo"
                                                  outlined
                                                  dense
                                                  maxlength="7"
                                                  :rules="rulesInputsNumber"
                                                  @keypress="ruleMoney($event,datos.pagoefectivo)"></v-text-field>
                                </div>

                                <v-divider class="mt-1"></v-divider>
                                <div class="mt-2">
                                    <span style="font-weight: bold;">Pago en cheque:</span>
                                    <v-text-field v-model="datos.pagocheque"
                                                  outlined
                                                  dense
                                                  maxlength="7"
                                                  :rules="rulesInputsNumber"
                                                  @keypress="ruleMoney($event,datos.pagocheque)"></v-text-field>
                                </div>

                                <v-divider class="mt-1"></v-divider>
                                <div class="mt-2">
                                    <span style="font-weight: bold;">Pago con documento:</span>
                                    <v-text-field v-model="datos.pagodocto"
                                                  v-on:blur="changeDocto()"
                                                  outlined
                                                  dense
                                                  maxlength="7"
                                                  :disabled="disabledDoctos"
                                                  :filled="disabledDoctos"
                                                  :rules="rulesInputsNumber"
                                                  @keypress="ruleMoney($event,datos.pagodocto)"></v-text-field>
                                </div>

                                <div v-if="showTipo">
                                    <v-divider class="mt-1"></v-divider>
                                    <div class="mt-2">
                                        <span style="font-weight: bold;">Tipo de documento:</span>
                                        <v-select outlined
                                                  dense
                                                  :items="DoctosArray"
                                                  v-model="datos.tipoDocto"
                                                  no-data-text="Sin datos"
                                                  item-text="dodescrip"
                                                  item-value="doclave"
                                                  :disabled="disabledDoctos"
                                                  :filled="disabledDoctos"
                                                  placeholder="Seleccione una opción"
                                                  :rules="ruleSelect">

                                        </v-select>
                                    </div>
                                </div>


                                <v-divider class="mt-1"></v-divider>
                                <div class="mt-2">
                                    <span style="font-weight: bold;">Pago en especie:</span>
                                    <v-text-field v-model="datos.pagoespecie"
                                                  outlined
                                                  dense
                                                  maxlength="7"
                                                  :rules="rulesInputsNumber"
                                                  @keypress="ruleMoney($event,datos.pagoespecie)"></v-text-field>
                                </div>

                                <div v-if="datos.pagoespecie != null && datos.pagoespecie != ''">
                                    <v-divider class="mt-1"></v-divider>
                                    <div class="mt-2">
                                        <span style="font-weight: bold;">Descripción de especie:</span>
                                        <v-text-field v-model="datos.descespecie"
                                                      v-on:blur="datos.descespecie = datos.descespecie != null ? datos.descespecie.trim() : null"
                                                      outlined
                                                      dense
                                                      maxlength="30"
                                                      :rules="rulesinputs"></v-text-field>
                                    </div>

                                </div>

                                <div v-if="validation.errorMontos" style="margin: -10px; margin-left: 0px;">
                                    <span class='spanError' style="color:red;font-size:13px">Debe ingresar un valor en alguno de los campos de Pago</span>
                                    <br />
                                </div>



                                <v-divider class="mt-1"></v-divider>



                                <div class="mt-2">
                                    <span style="font-weight: bold;">Persona que autoriza de la aseguradora:</span>
                                    <v-text-field v-model="datos.personaAutoriza"
                                                  v-on:blur="datos.personaAutoriza = datos.personaAutoriza != null ? datos.personaAutoriza.trim() : null"
                                                  outlined
                                                  dense
                                                  maxlength="30"
                                                  :rules="rulesinputs"></v-text-field>
                                </div>

                                <v-divider class="mt-1"></v-divider>



                                <div class="mt-2">
                                    <span style="font-weight: bold;">Persona que recibe:</span>
                                    <v-row>
                                        <v-col md="12">
                                            <v-radio-group v-model="datos.personaRecibe" :rules="rulesradios">
                                                <v-row>
                                                    <v-col cols="12"
                                                           sm="6"
                                                           md="6">
                                                        <v-radio label="Abogado" value="AB"></v-radio>
                                                        <v-radio label="NA" value="NA" :class="classdisabledNA"></v-radio>

                                                    </v-col>
                                                    <v-col cols="12"
                                                           sm="6"
                                                           md="6">
                                                        <v-radio label="Ajustador" value="AJ"></v-radio>
                                                        <v-radio label="Tercero" value="TR" :class="classdisabledTR"></v-radio>

                                                    </v-col>
                                                </v-row>
                                            </v-radio-group>
                                        </v-col>

                                    </v-row>
                                </div>

                                <v-divider class="mt-1"></v-divider>



                                <div class="mt-2">
                                    <span style="font-weight: bold;">Nombre de quien recibe:</span>
                                    <v-text-field v-model="datos.nombreRecibe"
                                                  outlined
                                                  dense
                                                  maxlength="30"
                                                  v-on:blur="datos.nombreRecibe = datos.nombreRecibe != null ? datos.nombreRecibe.trim() : null"
                                                  :rules="rulesinputs"></v-text-field>
                                </div>

                                <v-divider class="mt-1"></v-divider>
                                <div class="mt-2">
                                    <span style="font-weight: bold;">Fecha del pago:</span>
                                    <v-dialog ref="dialog"
                                              outlined
                                              v-model="modal"
                                              :return-value.sync="datos.fecha"
                                              persistent
                                              width="290px">
                                        <template v-slot:activator="{ on, attrs }">
                                            <div class="date-align-center">
                                                <v-text-field v-model="fecha"
                                                              label=""
                                                              readonly
                                                              :rules="rulestextfechas"
                                                              outlined
                                                              dense
                                                              v-bind="attrs"
                                                              v-on="on"></v-text-field>
                                            </div>
                                        </template>
                                        <v-date-picker v-model="datos.fecha"
                                                       locale="es-mx"
                                                       :max="maxDate"
                                                       :min="minDate"
                                                       scrollable>
                                            <v-spacer></v-spacer>
                                            <v-btn text
                                                   color="primary"
                                                   @click="modal = false">
                                                Cancel
                                            </v-btn>
                                            <v-btn text
                                                   color="primary"
                                                   @click="$refs.dialog.save(datos.fecha)">
                                                OK
                                            </v-btn>
                                        </v-date-picker>
                                    </v-dialog>
                                </div>


                            </div>


                            <div v-if="showOpciones">

                                <v-divider class="mt-1"></v-divider>
                                <div class="mt-2">
                                    <span style="font-weight: bold;">Nivel 1 :</span>
                                    <v-select outlined
                                              dense
                                              :items="listnivel1"
                                              v-model="datos.nivel1"
                                              no-data-text="Sin datos"
                                              item-text="ftn1desc"
                                              item-value="ftn1clave"
                                              placeholder="Seleccione una opción"
                                              :rules="ruleSelect">

                                    </v-select>
                                </div>

                                <div v-if="showNivel2">
                                    <v-divider class="mt-1"></v-divider>
                                    <div class="mt-2">
                                        <span style="font-weight: bold;">Nivel 2 :</span>
                                        <v-select outlined
                                                  dense
                                                  :items="listnivel2"
                                                  v-model="datos.nivel2"
                                                  no-data-text="Sin datos"
                                                  item-text="ftn2desc"
                                                  item-value="ftn2clave"
                                                  placeholder="Seleccione una opción"
                                                  :rules="ruleSelect">

                                        </v-select>
                                    </div>
                                </div>

                                <div v-if="showEfectivo">
                                    <v-divider class="mt-1"></v-divider>
                                    <div class="mt-2">
                                        <span style="font-weight: bold;">Efectivo:</span>
                                        <v-text-field v-model="datos.pagoefectivo"
                                                      outlined
                                                      dense
                                                      maxlength="7"
                                                      :rules="rulesInputsNumberEfectivo"
                                                      @keypress="ruleMoney($event,datos.pagoefectivo)"></v-text-field>
                                    </div>
                                </div>


                                <v-divider class="mt-1"></v-divider>
                                <div class="mt-2">
                                    <span style="font-weight: bold;">Observaciones:</span>
                                    <v-textarea @input="uppercase('observaciones')"
                                                v-on:blur="datos.observaciones = datos.observaciones != null ? datos.observaciones.trim() : null"
                                                :counter="600"
                                                maxlength="600"
                                                :rules="rulestextarea"
                                                outlined
                                                rows="3"
                                                v-model="datos.observaciones"></v-textarea>
                                </div>

                            </div>

                        </v-col>
                    </v-row>


                    <v-col md="12">
                        <v-row justify="center">
                            <v-btn dark
                                   class="ma-2"
                                   color="primary"
                                   title="Guardar"
                                   @click="guardar()"
                                   :disabled="disabledSave">
                                <span style='color: white;'>Guardar</span>
                            </v-btn>
                            <v-btn dark
                                   class="ma-2"
                                   color="#B0BEC5"
                                   title="Limpiar"
                                   @click="limpiarclick()"
                                   :disabled="disabledSave">
                                <span style='color: white;'>Limpiar</span>
                            </v-btn>
                            <v-btn dark
                                   class="ma-2"
                                   color="#FF4081"
                                   title="Cancelar"
                                   @click="cancelar()"
                                   :disabled="disabledSave">
                                <span style='color: white;'>Cancelar</span>
                            </v-btn>
                        </v-row>
                    </v-col>


                </v-card-text>
            </v-form>
        </v-card>
    </div>
</template>




<script>
    import Reporte from "@/services/ExpJur/ExpJur.service.js";
    import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
    import moment from 'moment';
    import { mapActions, mapMutations, mapState, mapGetters } from "vuex";
    export default {
        data() {
            return {
                showTipo: false,
                showRP: false,
                showOpciones: false,
                showNivel2: false,
                showEfectivo: false,
                disabledDoctos: false,
                validation: {
                    errorMontos: false,
                },
                maxDate: '',
                minDate: '',
                fecha: '',
                modal: false,
                disabledSave: false,
                validForm: true,
                nombreTercero: '',
                montodocto: null,
                doclave: null,
                d3foliodanios: null,
                DoctosArray: [],
                listnivel1: [],
                listnivel2: [],
                classdisabledNA: '',
                classdisabledTR: '',
                datos: {
                    termino: null,
                    fecha: null,
                    pagoefectivo: null,
                    pagocheque: null,
                    pagodocto: null,
                    tipoDocto: null,
                    pagoespecie: null,
                    descespecie: null,
                    personaAutoriza: null,
                    personaRecibe: null,
                    nombreRecibe: null,
                    observaciones: null,
                    nivel1: null,
                    nivel2: null
                },
                rulesradios: [v => !!v || 'Seleccione una opción'],
                rulestextfechas: [v => !!v || 'Campo requerido'],
                rulestextarea: [//v => !!v || 'Campo requerido',
                    v => {
                        if (v == null || v == '') {
                            return 'Campo requerido'
                        }
                        else {
                            if (v.length < 12) {
                                return 'Mínimo 12 Carácteres'
                            }
                            else if (v.length > 600) {
                                return 'Máximo 600 Carácteres'
                            }
                            else
                                return true
                        }
                    },
                ],
                rulesinputs: [//v => !!v || 'Campo requerido',
                    v => {
                        if (v == null || v == '') {
                            return 'Campo requerido'
                        }
                        else {
                            if (v.length < 8) {
                                return 'Mínimo 8 Carácteres'
                            }
                            else if (v.length > 30) {
                                return 'Máximo 30 Carácteres'
                            }
                            else
                                return true
                        }
                    },
                ],
                rulesInputsNumber: [(v) => {
                    if (v == null || v == '') {
                        return true;
                    }
                    else if (v.length > 7) {
                        return 'Inserte un valor valido';
                    }
                    else {
                        if (v < 100 || v > 1000000) {
                            return 'El campo debe ser mayor a 100 y menor a 1000000';
                        }
                        else
                            return new RegExp('^[0-9]+(\.[0-9]{1,2})?$').test(v) || "Inserte un valor valido"
                    }
                    return true
                }],
                rulesInputsNumberEfectivo: [(v) => {
                    if (v == null || v == '') {
                        return 'Inserte un valor valido';
                    }
                    else if (v.length > 7) {
                        return 'Inserte un valor valido';
                    }
                    else {
                        if (v < 100 || v > 1000000) {
                            return 'El campo debe ser mayor a 100 y menor a 1000000';
                        }
                        else
                            return new RegExp('^[0-9]+(\.[0-9]{1,2})?$').test(v) || "Inserte un valor valido"
                    }
                    return true
                }],
                ruleSelect: [(v) => !!v || "Campo requerido"],
                push: 0,
                displayInputs: {
                    d3id: 0
                },
            }
        },
        watch: {
            'datos.termino'(val) {
                this.limpiar();
                this.showRP = false;
                this.showOpciones = false;

                if (val == 'R') {
                    this.showRP = true;
                    let today = this.maxDate;
                    this.datos.fecha = today;
                    this.fecha = today;
                    
                    if (this.d3foliodanios != "" && this.d3foliodanios != null) {
                        const monto = this.montodocto;
                        this.datos.pagodocto = monto;
                        this.showTipo = true;
                        this.disabledDoctos = true;

                    }
                    Reporte.obtenerdoctosConclusion(this);
                    
                    this.classdisabledTR = 'disable-action';
                }
                if (val == 'P') {
                    let today = this.maxDate;
                    this.datos.fecha = today;
                    this.fecha = today;

                    this.showRP = true;
                    Reporte.obtenerdoctosConclusion(this);
                    this.classdisabledNA = 'disable-action';
                }
                if (val == 'I' || val == 'C' || val == 'S' || val == 'M') {
                    this.showOpciones = true;
                    Reporte.obtenerNivel1(this);

                }
            },
            'datos.pagoefectivo'(val) {
                if (val == null || val == '') {

                }
                else {
                    this.validation.errorMontos = false;
                }
            },
            'datos.pagocheque'(val) {
                if (val == null || val == '') {

                }
                else {
                    this.validation.errorMontos = false;
                }
            },

            'datos.pagodocto'(val) {
                
                    this.validation.errorMontos = false;
            },

            'datos.tipoDocto'(val){
                //20066
                if (val == 104) {
                    this.datos.pagodocto = 20066;
                }
                else if (this.datos.pagodocto == 20066 || this.datos.pagodocto == '20066'){
                    this.datos.pagodocto = '0';
                }
                if (val == 28) {
                    this.datos.pagodocto = 868;
                }
                else if (this.datos.pagodocto == 868 || this.datos.pagodocto == '868') {
                    this.datos.pagodocto = '0';
                }
            },
            'datos.pagoespecie'(val) {
                if (val == null || val == '') {
                    this.datos.descespecie = null;
                }
                else {
                    this.validation.errorMontos = false;
                }
            },
            'datos.nivel1'(val) {
                this.datos.nivel2 = null;
                this.datos.pagoefectivo = null;
                this.showEfectivo = false;
                this.showNivel2 = false;
                

                if (this.datos.termino == 'I') {
                    Reporte.obtenerNivel2(this);
                    this.showNivel2 = true;
                }
                if (this.datos.termino == 'M' && val == 12) {
                    Reporte.obtenerNivel2(this);
                    this.showNivel2 = true;
                }
                if (this.datos.termino == 'S' && val == 16) {
                    this.showEfectivo = true;
                }
                
            },
            'datos.fecha'(val) {
                this.fecha = val;
            },
        },
        methods: {
            ...mapMutations(["changeReporteMenuOption"]),
            changeDocto() {

                if (this.datos.pagodocto == null || this.datos.pagodocto == '') {
                    this.showTipo = false;
                    this.datos.tipoDocto = null;
                }
                else {
                    this.showTipo = true;
                }

            },
            async guardar() {
                this.disabledSave = true;
                this.$refs.form.validate();
                let error=0;
                if (this.datos.termino == 'R' || this.datos.termino == 'P') {
                    if ((this.datos.pagoefectivo == null || this.datos.pagoefectivo == '') &&
                        (this.datos.pagocheque == null || this.datos.pagocheque == '') &&
                        (this.datos.pagodocto == null || this.datos.pagodocto == '') &&
                        (this.datos.pagoespecie == null || this.datos.pagoespecie == '')) {
                        this.validation.errorMontos = true;
                        error++;
                    }
                    else {
                        this.validation.errorMontos = false;
                    }
                }


                if (this.$refs.form.validate() && error == 0) {
                    this.$swal({
                        position: 'center',
                        title: 'Guardando Conclusión de daños...',
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        didOpen: () => {
                            this.$swal.showLoading();
                        }
                    });
                    await Reporte.concluirDanos(this).then(response => {
                        setTimeout(() => {
                            this.$swal.close();
                            if (response) {
                                this.$swal({
                                    position: 'center',
                                    icon: 'success',
                                    title: 'Éxito',
                                    text: 'Se guardó correctamente la Conclusión de daños',
                                    showConfirmButton: true,
                                    allowOutsideClick: false,
                                }).then((result) => {
                                    if (result.isConfirmed) {
                                        this.cancelar();
                                    }
                                });
                                setTimeout(() => {
                                    this.$swal.close();
                                    this.cancelar();
                                }, 3000);

                            }
                            else {
                                this.$swal({
                                    position: 'center',
                                    icon: 'error',
                                    title: 'Error',
                                    text: 'Hubo un error al guardar la Conclusión de daños, Favor de avisar a Desarrollo',
                                    showConfirmButton: true,
                                    allowOutsideClick: false,
                                })
                            }

                        }, 1500);



                    });
                }
                else {
                    this.disabledSave = false;
                }
                


            },
            limpiarclick() {
                this.showOpciones = false;
                this.showRP = false;
                this.datos.termino = null;
                this.limpiar();
            },
            limpiar() {

                this.disabledDoctos = false;
                this.datos.pagoefectivo = null;
                this.datos.pagocheque = null;
                this.datos.pagodocto = null;
                this.datos.tipoDocto = null;
                this.datos.pagoespecie = null;
                this.datos.descespecie = null;
                this.datos.personaAutoriza = null;
                this.datos.personaRecibe = null;
                this.datos.nombreRecibe = null;
                this.datos.observaciones = null;
                this.datos.nivel1 = null;
                this.datos.nivel2 = null;


                this.classdisabledNA = '';
                this.classdisabledTR = '';
                this.validation.errorMontos = false;

                this.datos.fecha = null;
                this.fecha = null;

                this.showEfectivo = false;
                this.showNivel2 = false;
                this.showTipo = false;

                this.$refs.form.resetValidation();
            },
            cancelar() {
                if (this.push == 0) {
                    this.push++;
                    this.$router.go(-1);
                }

            },
            uppercase(input) {
                if (input == 'observaciones') {
                    if (this.datos.observaciones != '' && this.datos.observaciones != null) {
                        this.datos.observaciones = this.datos.observaciones.toUpperCase();
                    }
                }

            },
            ruleMoney: function ($event, value) {

                if (value == '' || value == null) {
                    if ($event.charCode >= 49 && $event.charCode <= 57) {
                        return true;
                    }
                    else {
                        $event.preventDefault();
                    }
                }
                else {
                    if (($event.charCode >= 48 && $event.charCode <= 57) || $event.charCode == 46) {
                        return true;
                    }
                    else {
                        $event.preventDefault();
                    }

                }
            },
        },
        async mounted() {
            let validaConc = await MetodosGenerales.getReporteEstatus(this);

            let clavetercero = await MetodosGenerales.obtenerSessionReporte('reporte');
            if (clavetercero.d3id == undefined) {
                this.$router.push({ name: `NoAutorizado` }).catch(error => error);
                return
            }
            this.changeReporteMenuOption(clavetercero.urlname);
            this.displayInputs = {
                d3id: clavetercero.d3id
            };

            let datosTercero = await Reporte.obtenerDatosTercero(this, clavetercero.d3id);
            if (validaConc == 2 || !datosTercero[0].d3danios || datosTercero[0].terminoDan != 'No' || datosTercero[0].valNegociacion != 1) {
                this.$router.push({ name: `NoAutorizado` }).catch(error => error);
                return
            }



            await Reporte.obtenerInfoDanios(this).then(response => {
                this.maxDate = response[0].today;
                this.nombreTercero = response[0].d3nombre;
                this.montodocto = response[0].d3montodocto;
                this.doclave = response[0].doclave;
                this.d3foliodanios = response[0].d3foliodanios;
                this.minDate = response[0].svfhreporte;



            });
            

        }
    }
</script>

<style>
    .date-align-center .v-input input {
        text-align: center !important;
    }
</style>
<style scoped>
    .type-label-style {
        font-family: "Roboto", sans-serif;
        font-weight: 400;
        font-size: 12px;
    }

    .type-text-style {
        font-family: "Poppins", sans-serif;
        font-weight: 700;
        font-size: 1.3em;
    }
</style>